'use client';

import {
  createContext,
  useContext,
  type ReactNode,
  useMemo,
  useCallback,
} from 'react';
import type { HttpHitlDisplayArgs } from '../components/tools/http/http-hitl-payload.utils';

type ChatProxyHistoryContextType = {
  fetchHistoryRequestForHitlDisplay: (
    requestId: string,
  ) => Promise<HttpHitlDisplayArgs | null>;
};

const ChatProxyHistoryContext = createContext<
  ChatProxyHistoryContextType | undefined
>(undefined);

type ChatProxyHistoryProviderProps = {
  children: ReactNode;
  fetchHistoryRequestForHitlDisplay: (
    requestId: string,
  ) => Promise<HttpHitlDisplayArgs | null>;
};

export function ChatProxyHistoryProvider({
  children,
  fetchHistoryRequestForHitlDisplay: fetchHistoryRequestForHitlDisplayProp,
}: ChatProxyHistoryProviderProps) {
  const fetchHistoryRequestForHitlDisplay = useCallback(
    async (requestId: string) => {
      return fetchHistoryRequestForHitlDisplayProp(requestId);
    },
    [fetchHistoryRequestForHitlDisplayProp],
  );

  const contextValue: ChatProxyHistoryContextType = useMemo(
    () => ({
      fetchHistoryRequestForHitlDisplay,
    }),
    [fetchHistoryRequestForHitlDisplay],
  );

  return (
    <ChatProxyHistoryContext.Provider value={contextValue}>
      {children}
    </ChatProxyHistoryContext.Provider>
  );
}

export function useChatProxyHistory() {
  return useContext(ChatProxyHistoryContext);
}
